<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-form @submit.prevent="submit" class="forma">
      <h2 class="header">Επεξεργασία Προφίλ</h2>
      <v-text-field class="mt-5" color="rgb(0,170,221)" label="'Ονομα" disabled v-model="firstName"></v-text-field>
      <v-text-field color="rgb(0,170,221)" label="Επώνυμο" disabled v-model="lastName"></v-text-field>
      <v-text-field color="rgb(0,170,221)" label="Email" disabled v-model="email"></v-text-field>
      <v-autocomplete
        color="rgb(0,170,221)"
        label="Νομός κατοικίας"
        :items="prefectures"
        item-value="option_key"
        item-text="option_value"
        @change="getMunicipalities"
        v-model="prefectureCode"
        :error-messages="prefectureErrors"
      ></v-autocomplete>
      <v-autocomplete
        color="rgb(0,170,221)"
        label="Δήμος κατοικίας"
        :items="municipalities"
        item-value="option_key"
        item-text="option_value"
        :loading="loadingLocal"
        v-model="municipalityCode"
        :error-messages="municipalityErrors"
      ></v-autocomplete>
      <v-text-field
        prefix="(+30)"
        color="rgb(0,170,221)"
        label="Κινητό"
        v-model="mobile"
        :error-messages="mobileErrors"
      ></v-text-field>
      <v-autocomplete
        color="rgb(0,170,221)"
        label="Ειδικότητα"
        :items="doctorTypes"
        item-value="option_key"
        item-text="option_value"
        v-model="docLicenseType"
        disabled
      ></v-autocomplete>

      <!-- <v-autocomplete
            color="rgb(0,170,221)"
            :items="medicalAssociations"
            item-value="option_key"
            item-text="option_value"
            label="Ιατρικός σύλλογος"
            v-model="docMedicalAssociation"
            :disabled="isPsychologist"
            :error-messages="docMedicalAssociationErrors">
      </v-autocomplete>-->

      <v-text-field
        color="rgb(0,170,221)"
        label="Αρ. Μητρώου Ιατρικού Συλλόγου"
        v-model="idNumber"
        disabled
      ></v-text-field>

      <v-text-field
        label="Ιατρικός σύλλογος"
        disabled
        v-model="medAss"></v-text-field>

      <div class="d-flex align-center justify-center my-5">
        <v-btn
          outlined
          color="rgb(74,74,74)"
          rounded
          depressed
          class="text-capitalize"
          @click="$router.replace('profile')"
        >Ακύρωση</v-btn>
        <v-btn
          type="submit"
          rounded
          depressed
          class="text-capitalize white--text ml-5"
          color="rgb(0,170,221)"
          :loading="$store.state.loading"
        >Αποθήκευση</v-btn>
      </div>
    </v-form>

    

    <v-snackbar v-model="fail" :timeout="3000" color="error">
      Αποτυχημένη επεξεργασία
      <v-icon @click="fail=false" color="white">mdi-close</v-icon>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  minLength,
  maxLength
} from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],

  created() {
    this.loadingLocal = true;
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/optionsList/greekPrefectures/el`)
      .then(res => {
        this.prefectures = res.data;

        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/doctorTypes/el`
        );
      })
      .then(res => {
        this.doctorTypes = res.data;
        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMedicalAssociations/el`
        );
      })
      .then(res => {
        this.medicalAssociations = res.data;
        return axios.get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefectureCode}`
        );
      })
      .then(res => {
        this.municipalities = res.data;
        this.loadingLocal = false;
      })
      .catch(err => {
        console.log(err);
        this.loadingLocal = false;
      });
  },

  data() {
    return {
      success: false,
      fail: false,
      loadingLocal: false,
      prefectures: [],
      doctorTypes: [],
      municipalities: [],
      medicalAssociations: [],
      firstName: this.$store.state.user.userProfile.firstName,
      lastName: this.$store.state.user.userProfile.lastName,
      email: this.$store.state.user.userProfile.email,
      prefectureCode: this.$store.state.user.currentLocation.prefectureCode,
      municipalityCode: this.$store.state.user.currentLocation.municipalityCode,
      docLicenseType: this.$store.state.user.doctorAccredations.docLicenseType,
      docMedicalAssociation: this.$store.state.user.doctorAccredations
        .docMedicalAssociation,
      idNumber: this.$store.state.user.doctorAccredations.idNumber,
      mobile: this.$store.state.user.userProfile.mobile,
      medAss: this.$store.state.user.doctorAccredations.greekMedicalAssociationName
    };
  },

  methods: {
    getMunicipalities() {
      this.loadingLocal = true;
      axios
        .get(
          `${process.env.VUE_APP_BASE_URL}/optionsList/greekMunicipalitiesOfPrefecture/el/${this.prefectureCode}`
        )
        .then(res => {
          console.log("hi", res);
          this.loadingLocal = false;
          this.municipalities = res.data;
        })
        .catch(err => {
          this.loadingLocal = false;
          console.log(err);
        });
    },

    submit() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        const doctorProfile = {
          userProfile: {
            mobile: this.mobile
          },
          currentLocation: {
            municipalityCode: this.municipalityCode
          }
        };

        this.$store
          .dispatch("editProfile", doctorProfile)
          .then(res => {
            this.$router.replace({name: 'profile', params: {success: true}});
          })
          .catch(err => {
            this.fail = true;
            console.log(err);
          });
      }
    }
  },

  validations: {
    mobile: {
      minLength: minLength(10),
      maxLength: maxLength(10),
      numeric
    },
    prefectureCode: {
      required
    },
    municipalityCode: {
      required
    }
  },

  computed: {
    mobileErrors() {
      const errors = [];
      if (!this.$v.mobile.$dirty) return errors;
      if (!this.$v.mobile.minLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.maxLength)
        errors.push("Εισάγετε έναν έγκυρο αριθμό τηλεφώνου");
      if (!this.$v.mobile.numeric) errors.push("Πρέπει να είναι αριθμός");
      return errors;
    },

    prefectureErrors() {
      const errors = [];
      if (!this.$v.prefectureCode.$dirty) return errors;
      if (!this.$v.prefectureCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    },

    municipalityErrors() {
      const errors = [];
      if (!this.$v.municipalityCode.$dirty) return errors;
      if (!this.$v.municipalityCode.required) errors.push("Υποχρεωτικό πεδίο");
      return errors;
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 100px;
  @media only screen and (max-width: 600px) {
    margin-top: 40px;
  }
}

.forma {
  width: 500px;
  @media only screen and (max-width: 600px) {
    width: auto;
  }
}
</style>